export default "__VITE_ASSET__5e464c8d__"